


















import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'MultiComplete',
  props: {
    value: Array,
    options: Array,
    display: [String, Function],
    itemKey: [String, Function],
  },
  data() {
    return {
      searchVal: '',
      idSuffix: Math.random().toString(16).substr(2, 8),
    };
  },
  computed: {
    getDisplay(): (item: any) => string {
      // This seems to be necessary for TypeScript to be able to refine the type
      const d = this.display;
      if (typeof d === 'string') {
        return (x: any) => x[d];
      } else {
        return d as (item: any) => string;
      }
    },
    getKey(): (item: any) => string {
      // This seems to be necessary for TypeScript to be able to refine the type
      const k = this.itemKey;
      if (typeof k === 'string') {
        return (x: any) => x[k];
      } else {
        return k as (item: any) => string;
      }
    },
  },
  methods: {
    selectFromList(e: InputEvent) {
      if (e.inputType === 'insertReplacementText') {
        this.enter();
      }
    },
    enter() {
      const searchPrefix = this.searchVal.toLocaleLowerCase();
      const choices = this.options
          .filter((x) => this.getDisplay(x).toLocaleLowerCase().startsWith(searchPrefix));
      if (choices.length > 0) {
        this.$emit('input', this.value.concat([choices[0]]));
        this.searchVal = '';
      }
    },
    remove(i: number) {
      this.$emit('input', this.value.filter((_, j) => j !== i));
    },
    clear() {
      this.$emit('input', []);
    },
  },
});
